import React from 'react';
import styled from 'styled-components';
import {EMPHASIS} from '@forecast-it/design-system';
import {LabelledButton} from './LabelledButton';

interface Props {
	email: string;
	onRemove: () => void;
	invalid?: boolean;
}

const Chip = styled.span<{$invalid: boolean}>`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	border-radius: 9999px;
	padding: 2px 8px;
	${p => p.theme.sys.font?.detail?.['1']}
	border: ${p => p.theme.sys.size.borderwidth.thin} solid
		${p => (p.$invalid ? p.theme.sys.color.border.error : p.theme.sys.color.border.decorative)};
	background: ${p => p.theme.sys.color.background.disabled['1']};
	color: ${p => (p.$invalid ? p.theme.sys.color.text.semantic.error : p.theme.sys.color.text.content.main)};
`;

export function RecipientChip({email, onRemove, invalid = false}: Props) {
	return (
		<Chip $invalid={invalid}>
			{email}
			<LabelledButton emphasis={EMPHASIS.LOW} label={'Remove ' + email} onPress={onRemove}>
				&times;
			</LabelledButton>
		</Chip>
	);
}
